import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Dashboard
        // Pages
        {
          name: 'このサイトについて',
          path: '/',
          component: () => import('@/views/dashboard/pages/About'),
        },
        {
          name: '原神用語辞書',
          path: 'gdic',
          component: () => import('@/views/dashboard/pages/GDic'),
        },
        {
          name: '登録単語一覧',
          path: 'gdic/list',
          component: () => import('@/views/dashboard/pages/GDicList'),
        },
        {
          name: '厳選辞書単語一覧',
          path: 'gdic/list/selection',
          component: () => import('@/views/dashboard/pages/GDic/Selection'),
        },
        {
          name: '更新履歴',
          path: 'gdic/log',
          component: () => import('@/views/dashboard/pages/GDicLog'),
        },
        // {
        //   name: '原神公式コミュ用ツール',
        //   path: 'tools',
        //   component: () => import('@/views/dashboard/pages/Tools'),
        // },
        // {
        //   name: '聖遺物スコア計算ツール',
        //   path: 'tools/calc/artifacts',
        //   component: () => import('@/views/dashboard/pages/Artifacts'),
        // },
        // {
        //   name: 'Webイベント回顧録',
        //   path: 'web-event',
        //   component: () => import('@/views/dashboard/pages/EventLog'),
        // },
        // {
        //   name: '魁!!スクショ塾',
        //   path: 'photo',
        //   component: () => import('@/views/dashboard/component/Typography'),
        // },
        // Tables
        // Maps
        // {
        //   name: 'Google Maps',
        //   path: 'maps/google-maps',
        //   component: () => import('@/views/dashboard/maps/GoogleMaps'),
        // },
        // Upgrade
        // {
        //   name: 'Upgrade',
        //   path: 'upgrade',
        //   component: () => import('@/views/dashboard/Upgrade'),
        // },
      ],
    },
  ],
})
